import moment from 'moment';
import React, { useState } from 'react';
import { Image, View } from 'react-native';
import { useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import Styles from '../../../constants/Styles';
import { Text } from '../../../globalComponents/NativeOverrides';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { GroupMessageProps } from '../../../store/types/soc_svc';
import FormattedTextViewer from './FormattedTextViewer';
import MediaHolder from './MediaHolder';
import OrderHolder from './OrderHolder';
import URLPreviewCard from './URLPreviewCard';

type ChatCardProps = { groupMessage: GroupMessageProps, me_ind:boolean }
function ChatCard({ groupMessage, me_ind }: ChatCardProps ) {
    const [ message_width, setMessageWidth ] = useState(0)
    const message_player:PublicPlayerProps | undefined = useSelector((state:any) => state.social.stored_players.find((p:PublicPlayerProps) => p.player_id == groupMessage.player_id), (left, right) => left?.player_id == right?.player_id)
    
    if(!groupMessage?.group_message_id){ return (<></>) }
    let media_size = 0
    if(groupMessage.message_images){ media_size += groupMessage.message_images.length }
    if(groupMessage.message_videos){ media_size += groupMessage.message_videos.length }
    let pic = message_player?.profile_pic
    if(!pic || pic === ''){
        pic = require('../../../assets/images/default-avatar.png')
    }

    return (
        <View style={{ flex:1 }}>
            <View style={{ flexDirection:'row', alignItems:'flex-start', margin:5 }}>
                <View style={{ flex:1/8 }}>
                    <Image source={pic} style={{ height:40, width:40, borderRadius:8 }} resizeMode='cover' />
                </View>
                <View style={{flex:7/8}}>
                    <View style={{ flexDirection:'row', alignItems:'flex-end', marginBottom:2 }}>
                        <Text style={{ marginRight:5 }} color={Colors.brand.midnight} weight='bold' size={14}>{message_player?.username}</Text>
                        <Text style={Styles.textStyles.grey300RegularRight12}>{moment(groupMessage.create_datetime).format('hh:mm a')}</Text>
                    </View>
                    {groupMessage.formatted_body ?
                        <FormattedTextViewer post_id={groupMessage.group_message_id} formatted_body={groupMessage.formatted_body} view_type='chat' text_fallback={groupMessage.message}/>
                    :<></>}
                    <View style={{ flex:1, padding:10 }} nativeID='post-media' onLayout={(ev) => {
                        const { width } = ev.nativeEvent.layout;
                        setMessageWidth(width)
                    }}>
                        {media_size > 0 ?
                        <MediaHolder width={message_width} view_mode='view' images={groupMessage.message_images??[]} videos={groupMessage.message_videos??[]}/>
                        :<></>}
                        {groupMessage.message_orders && groupMessage.message_orders.length > 0 ?
                        <OrderHolder view_mode='view' width={message_width} order_ids={groupMessage.message_orders} />
                        :<></>}
                        {groupMessage.message_urls && groupMessage.message_urls.length > 0 ?
                        <URLPreviewCard view_mode='view' hide_image={media_size>0 || (groupMessage.message_orders && groupMessage.message_orders.length >0)?true:false} url_preview={groupMessage.url_metadata[0]} url={groupMessage.message_urls[0]} width={message_width}/>
                        :<></>}
                    </View> 
                </View>
            </View>
        </View>        
    )
}

export default ChatCard